<template>
  <div class="home-box">
    <v-progress-linear indeterminate color="orange"></v-progress-linear>  
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "MobileLogin",
  components: {},
  data() {
    return {
      username: this.$route.query.username,
      password: this.$route.query.token
    };
  },
  mounted() {
    this.onDismissed();
    if (this.$route.query.username && this.$route.query.token) {
      this.login();
    }
  },
  computed: {
    ...mapGetters("auth", {
      errors: "errors",
      isLogged: "token",
      loading: "loading",
      profile: "profile"
    })
  },

  methods: {
    login() {
      if(this.$route.query.appos==='android'){

        this.$store
        .dispatch("auth/retrieveToken", {
          username: decodeURI(this.$route.query.username),
          password: decodeURI(this.$route.query.token)
        })
        .then(response => {
          if (response.statusText === "OK") {
            this.showLogin = false;
            this.$store.dispatch("auth/getUserProfile").then(res => {
              if (res.data.message === "Success") {
                res.data.data.role === "STUDENT"
                  ? this.$router.push("/")
                  : this.$router.push("/teacher/dashboard");
              }
            });
          }
        });

      }     
    },

    onDismissed() {
      this.$store.dispatch("auth/clearError");
    }
  }
};
</script>
<style>
.login-page {
  padding-bottom: 100px;
}
</style>

